// src/pages/orcamentos/OrcamentoReprovarModal.js
import React, { useEffect, useState } from 'react';
import Input from '../../components/input/Input';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';

const OrcamentoReprovarModal = ({ show, onHide, onConfirm }) => {
  const [motivo, setMotivo] = useState('');
  useEffect(() => { if (show) setMotivo(''); }, [show]);
  return <ModalContainer show={show} largura="520px">
    <ModalHeader><h5>Reprovar orçamento</h5><button type="button" className="btn-close" onClick={onHide} /></ModalHeader>
    <ModalBody><Input label="Motivo da reprovação" value={motivo} rows={4} size="100%" onChange={e => setMotivo(e.target.value)} /></ModalBody>
    <ModalFooter><button type="button" className="btn btn-secondary" onClick={onHide}>Cancelar</button><button type="button" className="btn btn-danger" disabled={!motivo.trim()} onClick={() => onConfirm(motivo.trim())}>Reprovar</button></ModalFooter>
  </ModalContainer>;
};

export default OrcamentoReprovarModal;
